export enum WidthType {
    AUTO,
    FULL,
    THREE_QUARTERS,
    TWO_THIRDS,
    HALF,
    ONE_THIRD,
    ONE_QUARTER
}